module.exports = __webpack_public_path__ + "img/3200_CT_2022_Bad.9e6fa67c.png";